import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-vehicle-version',
  templateUrl: './vehicle-version.component.html',
  styleUrls: ['./vehicle-version.component.scss']
})
export class VehicleVersionComponent implements OnInit {

  @Input() item;
  @Input() paddingTop = false;
  @Input() paddingBottom = false;

  get showEngineCapacity(): boolean {
    return this.item.engineCapacity > 0;
  }

  constructor() { }

  ngOnInit() {
  }

}
